import { Component, Element, h, Host, Prop } from "@stencil/core";
import { SortDirection } from "../../interfaces/directions";

@Component({
    tag: "ux-table-cell-sort-neo",
    styleUrls: ["table-cell-sort-neo.scss"],
    shadow: true
})
export class TableRowNeo {
    @Element() host!: HTMLUxTableCellSortNeoElement;

    /**
     * The direction of the sort
     */
    @Prop() readonly direction: SortDirection;

    render() {
        return (
            <Host>
                <ux-icon fill={this.direction === "ascending" ? "white" : undefined} name="chevron-up"></ux-icon>
                <ux-icon fill={this.direction === "descending" ? "white" : undefined} name="chevron-down"></ux-icon>
            </Host>
        );
    }
}
